import { render, staticRenderFns } from "./PropertyClientDetachDialog.vue?vue&type=template&id=062c7d5c"
import script from "./PropertyClientDetachDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyClientDetachDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports